import React from 'react'
import { FieldRenderProps } from 'react-final-form'
import { Form, FormFieldProps, Label } from 'semantic-ui-react'

interface Iprops extends FieldRenderProps<string, HTMLElement>,
    FormFieldProps { }

const TextAreaInput: React.FC<Iprops> = ({
    input,
    width,
    rows,
    placeholder,
    meta: { touched, error }
}) => {
    return (
        <Form.Field error={touched && !!error} width={width}>
            <textarea rows={rows} {...input} placeholder={placeholder} />

            {touched && error && (
                <Label basic color='red'>
                    {error}
                </Label>
            )}
        </Form.Field>
    );
};
export default TextAreaInput;
